import { Inject, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MaterialCheckModel, DeliveryCutoffTimes, ConfigInstanceToken, ConfigInterface } from '@evorait/pace-core';
import { faChevronDown, faChevronUp, faTrashAlt } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'pace-material-pricing-details-expandable',
    templateUrl: './material-pricing-details-expandable.component.html',
    styleUrls: ['./material-pricing-details-expandable.component.scss'],
    standalone: false,
})
export class MaterialPricingDetailsExpandableComponent implements OnInit {
    @Input() public material: MaterialCheckModel;
    @Input() public index: number;
    @Input() public displayCustomerPrice: boolean;
    @Input() public displayRepairPrice: boolean;

    @Output()
    public materialDeletedEvent = new EventEmitter<number>();

    public faChevronDown = faChevronDown;
    public faChevronUp = faChevronUp;
    public faTrashAlt = faTrashAlt;
    public isCollapsed = true;
    public isDeliveryCutoffTimeEnabled: boolean;
    public deliveryCutoffTimes: DeliveryCutoffTimes[] = [];

    public constructor(@Inject(ConfigInstanceToken) private configService: ConfigInterface) {}

    public ngOnInit(): void {
        this.isDeliveryCutoffTimeEnabled = this.configService.getEnableDeliveryCutoffTime();
        this.deliveryCutoffTimes = this.material.getDeliveryCutoffTimes();
    }

    public deleteMaterial(): void {
        this.materialDeletedEvent.emit(this.index);
    }
}
